// extracted by mini-css-extract-plugin
export default {"otherWordContainer":"CEFRBadge_otherWordContainer__J3Taj"};